app.controller('BrowseProductIndividualSolutionController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {


    const siteHelper = $rootScope.site_helper;

    const navigationIDs = $scope.navigation_ids;

    $scope.stock_navigation_ids = {
        base_component_id: "stock",
        parent_category_id: "product_recommended"
    };
    const clone_to_stock_keys = ['request_range_id', 'site_range_id', 'colour_id', 'style_id', 'product_id'];
    for (let i = 0; i < clone_to_stock_keys.length; i++) {
        const key = clone_to_stock_keys[i];
        if (navigationIDs[key]) {
            $scope.stock_navigation_ids[key] = navigationIDs[key];
        }
    }

    const productModel = $rootScope.factory.product_solution.getModel(navigationIDs);
    let canUpdateOptionIDs = [];

    $scope.can_update_option_text = "";

    $scope.product = null;
    $scope.category_href = null;

    const unbind_default_solution_cabinet_options_changed = $scope.$on('default_solution_cabinet_options_changed', function ($event, params) {
        for (let i = 0; i < $scope.product.option_product_model.term_model_list.length; i++) {
            const productOptionTerm = $scope.product.option_product_model.term_model_list[i];
            for (let j = 0; j < $scope.solution_option_terms.length; j++) {
                const solutionOptionTerm = $scope.solution_option_terms[j];
                if (solutionOptionTerm.option_id === productOptionTerm.option_id) {
                    if (solutionOptionTerm.currentOptionTermID) {
                        if (productOptionTerm.choices[solutionOptionTerm.currentOptionTermID]) {
                            $scope.product.option_term_ids[productOptionTerm.option_id] = solutionOptionTerm.currentOptionTermID;
                        }
                    } else {
                        delete $scope.product.option_term_ids[productOptionTerm.option_id];
                    }
                    break;
                }
            }
        }
    });
    $scope.$on('$destroy', unbind_default_solution_cabinet_options_changed);

    function apply_category_href() {

        const product = $scope.product;

        if (navigationIDs.browse_id === "solution" || !$scope.product) {
            return
        }

        const solutionID = product.solution_ids[0];

        const routeNavigationIDs = siteHelper.simpleCloneObject({
            browse_id: "solution",
            room_id: solutionID !== "bedroom_flat_pack" ? "kitchen" : "bedroom",
            solution_id: solutionID
        }, navigationIDs, true);

        $scope.category_href = $rootScope.navigation_manager.createNavigationModel(null, routeNavigationIDs, true).href;
    }

    function applyProduct() {
        const productID = navigationIDs.product_id;
        if (!productID) {
            return;
        }
        const product = productModel.choices[productID] ? productModel.choices[productID] : null;
        console.log("product")
        console.log(product)
        const optionProductModel = product.getOptionProductModel();
        product.option_term_ids = {};

        let optionTermIDs = null;

        if ($scope.solution_option_terms) {
            optionTermIDs = {}
            for (let i = 0; i < $scope.solution_option_terms.length; i++) {
                const solutionOptionTerm = $scope.solution_option_terms[i];
                const optionID = solutionOptionTerm.option_id
                if (solutionOptionTerm.currentOptionTermID) {
                    optionTermIDs[optionID] = solutionOptionTerm.currentOptionTermID;
                }
            }
        } else if (navigationIDs.browse_id !== "solution") {
            optionTermIDs = getInitialOptionTermIDs();
        }


        for (let optionID in optionProductModel.term_models) {
            const termModel = optionProductModel.term_models[optionID];
            if (termModel.default_choice_id && termModel.choices[termModel.default_choice_id] && !optionTermIDs[optionID]) {
                optionTermIDs[optionID] = termModel.default_choice_id;
            }
        }

        if (optionTermIDs) {
            for (let optionID in optionTermIDs) {
                const optionTermID = optionTermIDs[optionID]
                const termModel = optionProductModel.term_models[optionID];
                if (termModel && termModel.choices[optionTermID]) {
                    product.option_term_ids[optionID] = optionTermID;
                }
            }
        }

        $scope.product = product;

        apply_category_href();
    }

    function getCategoryCache() {

        const category_id = "solution_" + $scope.navigation_ids.solution_id;
        return $rootScope.service.cache_browse.requireCategoryCache(category_id);
    }

    function getInitialOptionTermIDs() {

        const category_cache = getCategoryCache();

        const optionTermConfig = $rootScope.service.product_solution.genericOptionTermConfig($scope.navigation_ids);
        const optionTermVariationIDs = siteHelper.simpleCloneObject($scope.navigation_ids);
        const cacheOptionTermIDs = category_cache.option_term_ids;

        const optionTermIDs = {};
        for (let i = 0; i < optionTermConfig.length; i++) {
            const config = optionTermConfig[i];
            const optionID = config.option_id;
            if (cacheOptionTermIDs[optionID]) {
                optionTermIDs[optionID] = cacheOptionTermIDs[optionID];
                continue;
            }
            optionTermVariationIDs.option_id = optionID;

            const optionTermModel = $rootScope.factory.option_term.getModel(optionTermVariationIDs);
            const choiceList = optionTermModel.choiceList();
            if (optionTermModel.disabled || !choiceList.length) {
                continue
            }

            const optionTermID = optionTermModel.default_choice_id && optionTermModel.choices[optionTermModel.default_choice_id] ? optionTermModel.default_choice_id : null;
            if (optionTermID) {
                optionTermIDs[optionID] = optionTermID;
            }

        }

        return optionTermIDs;
    }


    applyProduct();

    productModel.apiRequire(applyProduct)

    function show_pop_up_advert(pop_up_advert) {
        $bootstrapModal.open({
            templateUrl: 'CommonModalSimple.html',
            controller: 'CommonModalSimpleController',
            resolve: {
                items: pop_up_advert
            }
        })
    }


    $scope.checkPriceHandler = function (validateFormCallback, product) {


        $rootScope.service.product.addToCart(collectOrderBuild(product, null), function (success, messages, orderLine) {
            if (success) {

                product.calculated_price = orderLine._sublines_price;
                product.hide_price = false;
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        }, true);

    }

    $scope.addToCartHandler = function (validateFormCallback, product) {

        const adverts = $rootScope.service.advert.collectAdverts(product);

        function callAddToCart() {
            $rootScope.service.product.addToCart(collectOrderBuild(product, adverts), function (success, messages, orderLine) {
                if (success) {

                    canUpdateOptionIDs = [];
                    const can_update_option_models = [];
                    if ($scope.solution_option_terms) {
                        for (let i = 0; i < $scope.solution_option_terms.length; i++) {
                            const solutionOptionTerm = $scope.solution_option_terms[i];
                            const optionID = solutionOptionTerm.option_id
                            const solutionTermModel = solutionOptionTerm.option_term_model;
                            const savedOptionTermID = solutionOptionTerm.currentOptionTermID;
                            const submittedOptionTermID = product.option_term_ids[optionID];
                            if (submittedOptionTermID && solutionTermModel && (solutionTermModel.choices[submittedOptionTermID] || submittedOptionTermID === "NONE")) {
                                if (submittedOptionTermID !== savedOptionTermID) {
                                    canUpdateOptionIDs.push(optionID);
                                    can_update_option_models.push(solutionTermModel);
                                }
                            }
                        }
                    }
                    let text = "";
                    for (let i = 0; i < can_update_option_models.length; i++) {
                        if (i !== 0) {
                            if (i === can_update_option_models.length - 1) {
                                text += " & ";
                            } else {
                                text += ", ";
                            }
                        }
                        text += can_update_option_models[i].name;
                    }
                    $scope.can_update_option_text = text;

                    product.calculated_price = '';
                    product.hide_price = true;

                    const post_pop_ups = $rootScope.service.advert.onAddedToCartAdverts(adverts)
                    const post_pop_up = post_pop_ups.length > 0 ? post_pop_ups[0] : null;
                    if (post_pop_up) {
                        show_pop_up_advert(post_pop_up);
                    }
                }
                if (validateFormCallback) {
                    validateFormCallback(success, messages);
                }
            }, false);
        }

        const pre_pop_ups = $rootScope.service.advert.preAddToCartAdverts(adverts, callAddToCart);
        const pre_pop_up = pre_pop_ups.length > 0 ? pre_pop_ups[0] : null;

        if (pre_pop_up) {
            show_pop_up_advert(pre_pop_up);
        } else {
            callAddToCart()
        }
    };

    $scope.save_to_default_options = function () {
        if ($scope.solution_option_terms) {
            for (let i = 0; i < canUpdateOptionIDs.length; i++) {
                const optionID = canUpdateOptionIDs[i];
                const submittedOptionTermID = $scope.product.option_term_ids[optionID];
                if (!submittedOptionTermID) {
                    continue;
                }

                for (let j = 0; j < $scope.solution_option_terms.length; j++) {
                    const solutionOptionTerm = $scope.solution_option_terms[j];
                    const solutionOptionID = solutionOptionTerm.option_id
                    if (solutionOptionID !== optionID) {
                        continue;
                    }
                    const solutionTermModel = solutionOptionTerm.option_term_model;
                    if (solutionTermModel.choices[submittedOptionTermID] || submittedOptionTermID === "NONE") {
                        solutionOptionTerm.currentOptionTermID = submittedOptionTermID;
                    }
                    break;
                }
                if ($scope.saveSolutionCabinetOptionTerms) {
                    $scope.saveSolutionCabinetOptionTerms();
                }
            }
            canUpdateOptionIDs.length = 0;
            $scope.can_update_option_text = "";
        }
    }

    $scope.onOptionTermChoiceSelected = function () {
        canUpdateOptionIDs.length = 0;
        $scope.can_update_option_text = "";
    }

    function collectOrderBuild(product, adverts) {

        const browseID = navigationIDs.browse_id;
        const siteRangeID = navigationIDs.site_range_id;
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID)
        let colourID = navigationIDs.colour_id;
        const edgeOptionID = navigationIDs.edge_option_id;
        const handleColourID = navigationIDs.handle_colour_id;

        const optionTermIDs = {};
        const options = {};

        const optionProductModel = product.getOptionProductModel();
        for (let optionID in optionProductModel.term_models) {
            const optionTermModel = optionProductModel.term_models[optionID];
            let optionTermID = product.option_term_ids[optionID];
            optionTermID = optionTermID !== "NONE" ? optionTermID : null;
            optionTermIDs[optionID] = optionTermID;
            if (optionTermModel.is_server_option_term && !optionTermModel.is_complex_option_term) {
                options[optionID] = optionTermID;
            }
        }
        let clicboxColour = optionTermIDs.clicbox_colour;
        const drawer_colour = optionTermIDs.drawer_colour;
        const hinge_colour = optionTermIDs.hinge_colour;
        const handle_style = optionTermIDs.handle_style;

        const overhang = product.option_term_ids.overhang;
        const categoryCartID = $scope.category_cart_id ? $scope.category_cart_id : null;

        colourID = colourID ? colourID : productModel.default_colour_id;
        clicboxColour = clicboxColour ? clicboxColour : navigationIDs.option_term_id;

        const orderLine = {

            type: "complete",
            unit: product.id,

            solution_id: product.solution_id,
            quantity: product.quantity,
            cost: product.calculated_price,

            range: requestRangeID,
            site_range: navigationIDs.site_range_id,
            colour: colourID,
            style: navigationIDs.style_id,

            edging: edgeOptionID,
            carcass_colour: clicboxColour,
            hettich_colour: drawer_colour,
            hinge_colour: hinge_colour,
            handle_colour: handleColourID,
            door_type: handle_style,

            overhang: overhang === "overhang_yes",
            options: options,

            inner_drawer_range: product.inner_drawer_request_range_id,
            inner_drawer_colour: product.inner_colour_id,
            inner_drawer_style: product.inner_style_id,

            rotate_grain: !!product.rotate_grain,
            hinge_hole_side: product.hinge_hole_side,
            internal_fitted: product.option_term_values.internal ? product.option_term_values.internal.fitted : null,

            height: product.height,
            width: product.width,

            rigid: product.assembly_id === "rigid",
            include_shelf_pack: true,
            completeRange: requestRangeID,

            category_cart_id: categoryCartID,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,
            adverts: adverts,

            group_name: product.group_name,
            requires_hettich_colour: !!product.requires_hettich_colour,
            requires_hinge_colour: !!product.requires_hinge_colour


        };

        return {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            carcass_colour: orderLine.carcass_colour,
            lines: [orderLine],
            category_cache: getCategoryCache()
        };
    }
}]);